<template>
  <v-app>
    <ForgotPassword v-if="!isAuth && isForgot" />
    <ValidationCode v-if="!isAuth && isValidation"/>
    <!-- Dacă nu este autentificat -->
    <login-view v-if="!isAuth && !isForgot && !isValidation"></login-view>

    <!-- Dacă este autentificat și a ales SuperAdmin -->
    <super-admin v-else-if="isAuth && isSuperAdminChoice"></super-admin>

    <!-- Dacă este autentificat și nu a ales SuperAdmin -->
    <home-view v-else-if="isAuth"></home-view>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppSettings from "@/settings/appSettings"
import Device from "@/settings/device"
import LoginView from "./views/AUTH/LoginView.vue"
import Jwt from "@/services/JwtServices"
import HomeView from './views/HomeView.vue'
import SuperAdmin from './views/ADMIN/SuperAdmin.vue'
import ForgotPassword from './views/AUTH/ForgotPassword.vue'
import ValidationCode from './views/AUTH/ValidationCode.vue'

export default defineComponent({
  name: 'App',
  components: {
    LoginView,
    HomeView,
    ForgotPassword,
    SuperAdmin,
    ValidationCode
  },
  data() {
    return {
      isSuperAdminChoice: localStorage.getItem("ERA_SuperAdminChoice") === "true",
      isAuth: Jwt.isAuthenticated(),
      url: AppSettings.API_Url,
      isPC: Device
    }
  },
  computed: {
    isForgot() {
      return this.$route.name === 'ForgotPassword' || this.$route.path === '/forgot-password'
    },
    isValidation() {
      return this.$route.name === 'ValidationCode' || this.$route.path === '/validation-code'
    },
    isSuperAdmin(): boolean {
      return Jwt.isSuperAdmin()
    }
  }
})
</script>
